import { render, staticRenderFns } from "./ResizableImageTemplate.vue?vue&type=template&id=3044f44e&scoped=true"
import script from "./ResizableImageTemplate.vue?vue&type=script&lang=js"
export * from "./ResizableImageTemplate.vue?vue&type=script&lang=js"
import style0 from "./ResizableImageTemplate.vue?vue&type=style&index=0&id=3044f44e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3044f44e",
  null
  
)

export default component.exports